/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
import React from 'react';
import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Iconify from '../Iconify';
import CustomButton from '../CustomButton';
import useResponsive from '../../hooks/useResponsive';
import CustomNumber from '../customNumber';
import NumberTextField from '../NumberTextField';

function AppPricing() {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  // montant
  const [price, setPrice] = React.useState(0);
  const [number, setNumber] = React.useState(0);
  const [montant, setMontant] = React.useState([0]);
  const [nbBillet, setNbBillet] = React.useState([0]);
  const [commission, setCommission] = React.useState();
  const [fees, setFees] = React.useState(9);
  const [revenu, setRevenu] = React.useState(0);



  React.useEffect(() => {
    (async () => {
      try {
        console.log('ok');
        const total = number * price
        const com = total * 9 / 100
        const rev = total - com
        setCommission(com)
        setRevenu(rev);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [price, number]);

  const suppBillet = (index) => {
    setMontant((existItem) => {
      return [...existItem.slice(0, index), ...existItem.slice(index + 1)];
    });
    setNbBillet((existItem) => {
      return [...existItem.slice(0, index), ...existItem.slice(index + 1)];
    });
  };

  return (
    <div id="pricing" className="block pricingBlock ">
      <Container maxWidth="xl">
        <Stack paddingX={{ xs: 0, sm: 10, md: 20, lg: 30, xl: 40 }} spacing={1}>
          <Typography textAlign="center" variant="h5" sx={{ color: 'orangered' }}>
            Tarifs
          </Typography>
          <Typography textAlign="center" variant="h2">
            Des offres adaptées à <span style={{ color: '#5E17EB' }}>chacun de vous</span>
          </Typography>
          <Typography textAlign="center" color="text.secondary" fontSize={20}>
            Choptonticket est <span style={{ color: 'orangered' }}>gratuit</span> pour les événements gratuits !
          </Typography>
        </Stack>


        <Box paddingTop={5}>
          <Grid container spacing={3} display='flex' justifyContent='center' >
            <Grid item xs={12} sm={6} display='flex' justifyContent='center' >
              <Stack spacing={6} justifyContent={'center'} alignItems={'center'} sx={{
                width: '100%',
                padding: { xs: 2, sm: 5 },
                backdropFilter: "blur(12px)", // flou plus marqué
                WebkitBackdropFilter: "blur(12px)", // Safari support
                background: "rgba(255, 255, 255, 0.15)", // fond translucide
                border: "1px solid rgba(255, 255, 255, 0.3)", // léger contour
                boxShadow: "0 4px 30px rgba(0,0,0,0.1)", // ombre douce
                borderRadius: "16px",
                transition: "all 0.3s ease",
                "&:hover": {
                  // background: "rgba(255, 255, 255, 0.25)", // un peu plus opaque au hover
                  // transform: "scale(1.02)", // effet subtil au survol
                },
              }}>

                <Typography color={'text.secondary'} fontSize={20}><span style={{ fontWeight: 'bold', fontSize: '80px', color: '#5E17EB' }}>9%</span> par ticket vendu</Typography>

                <Stack direction='column' padding={2} spacing={1.5}>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'white' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Types de billets illimités</Typography>
                    </Box>
                  </Stack>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'white' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Widget de vente 100% personnalisable pour votre site</Typography>
                    </Box>
                  </Stack>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'white' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Analyses détaillées du public</Typography>
                    </Box>
                  </Stack>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: '#5e17eb1f' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Analyses des ventes</Typography>
                    </Box>
                  </Stack>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'white' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Accès équipe & autorisations</Typography>
                    </Box>
                  </Stack>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'white' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Affiliation partenaires</Typography>
                    </Box>
                  </Stack>
                  <Stack direction='row' spacing={2}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'white' }}>
                      <Iconify icon='ic:baseline-check' sx={{ height: 20, width: 20, color: '#5E17EB' }} />
                    </Avatar>
                    <Box>
                      <Typography color={'text.secondary'} fontSize={18}>Campagnes email, Facebook, push</Typography>
                    </Box>
                  </Stack>
                </Stack>
                
                  <CustomButton type={'primaire'} size='large' fullWidth buttonText={'Commencer maintenant'} href='/bo'/>


              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} display='flex' justifyContent='center' >
              <Stack spacing={4} justifyContent={'center'} alignItems={'center'} sx={{
                width: '100%',
                padding: { xs: 2, sm: 5 },
                backdropFilter: "blur(12px)", // flou plus marqué
                WebkitBackdropFilter: "blur(12px)", // Safari support
                background: "rgba(255, 255, 255, 0.15)", // fond translucide
                border: "1px solid rgba(255, 255, 255, 0.3)", // léger contour
                boxShadow: "0 4px 30px rgba(0,0,0,0.1)", // ombre douce
                borderRadius: "16px",
                transition: "all 0.3s ease",
                "&:hover": {
                  // background: "rgba(255, 255, 255, 0.25)", // un peu plus opaque au hover
                  // transform: "scale(1.02)", // effet subtil au survol
                },
              }}>

                <Typography color={'text.primary'} fontWeight={'bold'} textAlign={'center'} fontSize={25}>Calculez vos gains potentiels</Typography>

                <Stack direction='column' spacing={1.5}>
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5}>
                    <Stack direction='column' spacing={1.5}>
                      <Typography fontSize={18} color={'text.secondary'}>Prix du billet (FCFA)</Typography>
                      <NumberTextField value={price} onChange={(value) => setPrice(value)} fullWidth />
                    </Stack>
                    <Stack direction='column' spacing={1.5}>
                      <Typography fontSize={18} color={'text.secondary'}>Billets vendus</Typography>
                      <NumberTextField value={number} onChange={(e) => setNumber(e)} fullWidth />
                    </Stack>
                  </Stack>
                </Stack>
                <Stack spacing={1} sx={{ width: '100%', border: '1px solid gainsboro', borderRadius: '16px', padding: 2, bgcolor: '#f2f2f2' }} justifyContent={'center'}>
                  <Typography textAlign={'center'} color={'text.secondary'} fontSize={18}>Votre paiement estimé</Typography>
                  <Typography textAlign={'center'} sx={{ color: '#5E17EB' }} variant='h3'>{revenu} FCFA</Typography>
                  <Typography textAlign={'center'} color={'text.secondary'} fontSize={20}>Après déduction de {commission} FCFA de commission</Typography>
                </Stack>
              </Stack>
            </Grid>

          </Grid>
        </Box>

      </Container>
    </div>
  );
}

export default AppPricing;
